/**
 * Frosted glass panel used across marketing and account pages.
 */
export default function GlassPanel({ children, className = "" }) {
  return (
    <div
      className={`glass-panel ${className}`.trim()}
    >
      {children}
    </div>
  );
}
